import { useState } from 'react';

export interface UseDialogActionReturn {
    states: {
        isDialogOpened: boolean;
        isProcessing: boolean;
    };
    handlers: {
        handleOpen: () => void;
        handleCancel: () => void;
        handleConfirm: () => Promise<void>;
    };
}

export const useDialogAction = <T = void>(
    dialogAction: () => Promise<T>,
    onError?: (error?: Error) => void
): UseDialogActionReturn => {
    const [isDialogOpened, setIsDialogOpened] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleOpen = () => {
        setIsDialogOpened(true);
    };

    const handleCancel = () => {
        setIsDialogOpened(false);
    };

    const handleConfirm = async () => {
        setIsProcessing(true);
        try {
            await dialogAction();
        } catch (error) {
            if (onError !== undefined) {
                onError(error);
            }
        }
        setIsProcessing(false);
        setIsDialogOpened(false);
    };

    return {
        states: {
            isDialogOpened,
            isProcessing,
        },
        handlers: {
            handleOpen,
            handleCancel,
            handleConfirm,
        },
    };
};
